import { cva, VariantProps } from 'class-variance-authority';

export const root = cva(['overflow-hidden', 'bg-white'], {
  variants: {
    shadow: {
      true: ['shadow'],
      false: [],
    },
    rounded: {
      true: ['rounded-2xl'],
      false: [],
    },
  },
});

export type RootStyleProps = VariantProps<typeof root>;

export const content = cva(['px-4', 'py-5', 'sm:p-6'], {
  variants: {
    background: {
      white: ['bg-white'],
      gray: ['bg-white'],
    },
  },
});

export type ContentStyleProps = VariantProps<typeof content>;

export const header = cva(['px-4', 'pt-4', 'pb-6'], {
  variants: {
    background: {
      white: ['bg-white'],
      gray: ['bg-white'],
    },
  },
});

export type HeaderStyleProps = VariantProps<typeof header>;

export const footer = cva(['px-4', 'py-4', 'sm:px-6'], {
  variants: {
    background: {
      white: ['bg-white'],
      gray: ['bg-white'],
    },
  },
});

export type FooterStyleProps = VariantProps<typeof header>;
